/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/binoculars/binoculars.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface V1PodLogOptions
 */
export interface V1PodLogOptions {
    /**
     * APIVersion defines the versioned schema of this representation of an object.
     * Servers should convert recognized schemas to the latest internal value, and
     * may reject unrecognized values.
     * More info: https://git.k8s.io/community/contributors/devel/sig-architecture/api-conventions.md#resources
     * +optional
     * @type {string}
     * @memberof V1PodLogOptions
     */
    apiVersion?: string;
    /**
     * The container for which to stream logs. Defaults to only container if there is one container in the pod.
     * +optional
     * @type {string}
     * @memberof V1PodLogOptions
     */
    container?: string;
    /**
     * Follow the log stream of the pod. Defaults to false.
     * +optional
     * @type {boolean}
     * @memberof V1PodLogOptions
     */
    follow?: boolean;
    /**
     * insecureSkipTLSVerifyBackend indicates that the apiserver should not confirm the validity of the
     * serving certificate of the backend it is connecting to.  This will make the HTTPS connection between the apiserver
     * and the backend insecure. This means the apiserver cannot verify the log data it is receiving came from the real
     * kubelet.  If the kubelet is configured to verify the apiserver's TLS credentials, it does not mean the
     * connection to the real kubelet is vulnerable to a man in the middle attack (e.g. an attacker could not intercept
     * the actual log data coming from the real kubelet).
     * +optional
     * @type {boolean}
     * @memberof V1PodLogOptions
     */
    insecureSkipTLSVerifyBackend?: boolean;
    /**
     * Kind is a string value representing the REST resource this object represents.
     * Servers may infer this from the endpoint the client submits requests to.
     * Cannot be updated.
     * In CamelCase.
     * More info: https://git.k8s.io/community/contributors/devel/sig-architecture/api-conventions.md#types-kinds
     * +optional
     * @type {string}
     * @memberof V1PodLogOptions
     */
    kind?: string;
    /**
     * If set, the number of bytes to read from the server before terminating the
     * log output. This may not display a complete final line of logging, and may return
     * slightly more or slightly less than the specified limit.
     * +optional
     * @type {number}
     * @memberof V1PodLogOptions
     */
    limitBytes?: number;
    /**
     * Return previous terminated container logs. Defaults to false.
     * +optional
     * @type {boolean}
     * @memberof V1PodLogOptions
     */
    previous?: boolean;
    /**
     * A relative time in seconds before the current time from which to show logs. If this value
     * precedes the time a pod was started, only logs since the pod start will be returned.
     * If this value is in the future, no logs will be returned.
     * Only one of sinceSeconds or sinceTime may be specified.
     * +optional
     * @type {number}
     * @memberof V1PodLogOptions
     */
    sinceSeconds?: number;
    /**
     * An RFC3339 timestamp from which to show logs. If this value
     * precedes the time a pod was started, only logs since the pod start will be returned.
     * If this value is in the future, no logs will be returned.
     * Only one of sinceSeconds or sinceTime may be specified.
     * +optional
     * @type {string}
     * @memberof V1PodLogOptions
     */
    sinceTime?: string;
    /**
     * If set, the number of lines from the end of the logs to show. If not specified,
     * logs are shown from the creation of the container or sinceSeconds or sinceTime
     * +optional
     * @type {number}
     * @memberof V1PodLogOptions
     */
    tailLines?: number;
    /**
     * If true, add an RFC3339 or RFC3339Nano timestamp at the beginning of every line
     * of log output. Defaults to false.
     * +optional
     * @type {boolean}
     * @memberof V1PodLogOptions
     */
    timestamps?: boolean;
}

export function V1PodLogOptionsFromJSON(json: any): V1PodLogOptions {
    return V1PodLogOptionsFromJSONTyped(json, false);
}

export function V1PodLogOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1PodLogOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apiVersion': !exists(json, 'apiVersion') ? undefined : json['apiVersion'],
        'container': !exists(json, 'container') ? undefined : json['container'],
        'follow': !exists(json, 'follow') ? undefined : json['follow'],
        'insecureSkipTLSVerifyBackend': !exists(json, 'insecureSkipTLSVerifyBackend') ? undefined : json['insecureSkipTLSVerifyBackend'],
        'kind': !exists(json, 'kind') ? undefined : json['kind'],
        'limitBytes': !exists(json, 'limitBytes') ? undefined : json['limitBytes'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'sinceSeconds': !exists(json, 'sinceSeconds') ? undefined : json['sinceSeconds'],
        'sinceTime': !exists(json, 'sinceTime') ? undefined : json['sinceTime'],
        'tailLines': !exists(json, 'tailLines') ? undefined : json['tailLines'],
        'timestamps': !exists(json, 'timestamps') ? undefined : json['timestamps'],
    };
}

export function V1PodLogOptionsToJSON(value?: V1PodLogOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'apiVersion': value.apiVersion,
        'container': value.container,
        'follow': value.follow,
        'insecureSkipTLSVerifyBackend': value.insecureSkipTLSVerifyBackend,
        'kind': value.kind,
        'limitBytes': value.limitBytes,
        'previous': value.previous,
        'sinceSeconds': value.sinceSeconds,
        'sinceTime': value.sinceTime,
        'tailLines': value.tailLines,
        'timestamps': value.timestamps,
    };
}

